import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBrandsProps, IconRender } from '../types.ts';

const Linkedin = React.forwardRef<SVGSVGElement | null, IconBrandsProps>(function Linkedin({ colored, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M4.22266 2.75H19.7773C20.5904 2.75 21.25 3.40957 21.25 4.22266V19.7773C21.25 20.5904 20.5904 21.25 19.7773 21.25H4.22266C3.40957 21.25 2.75 20.5904 2.75 19.7773V4.22266C2.75 3.40957 3.40957 2.75 4.22266 2.75Z'
          stroke={colored ? 'transparent' : color}
          strokeWidth='1.5'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18 18H15.5344V13.8005C15.5344 12.6491 15.0969 12.0057 14.1855 12.0057C13.1941 12.0057 12.6762 12.6753 12.6762 13.8005V18H10.3V10H12.6762V11.0776C12.6762 11.0776 13.3906 9.75559 15.0883 9.75559C16.7852 9.75559 18 10.7918 18 12.9349V18ZM7.46523 8.95246C6.65586 8.95246 6 8.29146 6 7.47623C6 6.66101 6.65586 6 7.46523 6C8.27461 6 8.93008 6.66101 8.93008 7.47623C8.93008 8.29146 8.27461 8.95246 7.46523 8.95246ZM6.23828 18H8.71602V10H6.23828V18Z'
          fill={colored ? 'transparent' : color}
        />
        {/* colored */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.7778 22H4.22222C2.99492 22 2 21.0051 2 19.7778V4.22222C2 2.99492 2.99492 2 4.22222 2H19.7778C21.0051 2 22 2.99492 22 4.22222V19.7778C22 21.0051 21.0051 22 19.7778 22ZM15.5344 18H18V12.9349C18 10.7918 16.7852 9.75559 15.0883 9.75559C13.3906 9.75559 12.6762 11.0776 12.6762 11.0776V10H10.3V18H12.6762V13.8005C12.6762 12.6753 13.1941 12.0057 14.1855 12.0057C15.0969 12.0057 15.5344 12.6491 15.5344 13.8005V18ZM6 7.47623C6 8.29146 6.65586 8.95246 7.46523 8.95246C8.27461 8.95246 8.93008 8.29146 8.93008 7.47623C8.93008 6.66101 8.27461 6 7.46523 6C6.65586 6 6 6.66101 6 7.47623ZM8.71602 18H6.23828V10H8.71602V18Z'
          fill={colored ? '#0072B1' : 'transparent'}
        />
      </>
    ),
    [colored],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'linkedin-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Linkedin;
